"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NonEnterpriseOrganization = exports.EnterpriseOrganization = exports.EnterpriseRole = exports.EnterpriseWithDefaultOrganizationAndMetadata = exports.EnterpriseWithDefaultOrganization = exports.Enterprise = exports.EnterpriseVisibility = void 0;
exports.isEnterpriseOrganization = isEnterpriseOrganization;
exports.isNonEnterpriseOrganization = isNonEnterpriseOrganization;
exports.isEnterpriseFullyDecoratedOrganizationMember = isEnterpriseFullyDecoratedOrganizationMember;
exports.isNonEnterpriseFullyDecoratedOrganizationMember = isNonEnterpriseFullyDecoratedOrganizationMember;
const zod_1 = require("zod");
const handle_1 = require("../handle");
const identifier_1 = require("../identifier");
const validation_1 = require("../validation");
const organization_1 = require("./organization");
exports.EnterpriseVisibility = zod_1.z.enum(["public", "private"]);
exports.Enterprise = zod_1.z.object({
    uid: identifier_1.EnterpriseUid,
    handle: handle_1.EnterpriseHandle,
    displayName: zod_1.z.string(),
    visibility: exports.EnterpriseVisibility,
    defaultOrganizationUid: identifier_1.OrganizationUid,
    createdAt: validation_1.Timestamp,
    updatedAt: validation_1.Timestamp,
});
/**
 * Useful type that can usually allow the enterprise to act more as a standard "Account" (which is IUserData | Organization)
 */
exports.EnterpriseWithDefaultOrganization = zod_1.z.object({
    ...exports.Enterprise.shape,
    defaultOrganization: organization_1.Organization,
});
/**
 * When the user is a member of the enterprise, we usually further want to be able to e.g. resolve plan entitlements for
 * the enterprise, which requires the metadata as well
 */
exports.EnterpriseWithDefaultOrganizationAndMetadata = zod_1.z.object({
    ...exports.Enterprise.shape,
    defaultOrganization: organization_1.OrganizationWithMetadata,
});
/**
 * Enterprise role is currently the same as an organization role, because it is based on the user's membership of the
 *  default organization for the enterprise
 */
exports.EnterpriseRole = organization_1.OrganizationRole;
exports.EnterpriseOrganization = zod_1.z.object({
    ...organization_1.Organization.shape,
    enterpriseUid: identifier_1.EnterpriseUid,
});
exports.NonEnterpriseOrganization = zod_1.z.object({
    ...organization_1.Organization.shape,
    enterpriseUid: zod_1.z.optional(zod_1.z.undefined()),
});
function isEnterpriseOrganization(organization) {
    return !!organization && organization.enterpriseUid !== undefined;
}
function isNonEnterpriseOrganization(organization) {
    return !!organization && organization.enterpriseUid === undefined;
}
// Type guards for the unioned FullyDecoratedOrganizationMember type
function isEnterpriseFullyDecoratedOrganizationMember(membership) {
    return !!membership.enterprise;
}
function isNonEnterpriseFullyDecoratedOrganizationMember(membership) {
    return membership.enterprise === undefined;
}
//# sourceMappingURL=enterprise.js.map